import { ICON_CHEVRON_DIRECTION } from '../../../Icon'
import { TabScrollButton } from '../../TabScrollButton'

import * as styles from './TabScrollListButtons.module.css'

function TabScrollListButtons({
  buttonProps,
  isNextBtnVisible,
  isPrevBtnVisible,
  leftArrowClassName = styles.leftArrow,
  rightArrowClassName = styles.rightArrow,
  onClickNextBtn,
  onClickPrevBtn,
}) {
  return (
    <>
      <TabScrollButton
        buttonProps={buttonProps}
        className={leftArrowClassName}
        direction={ICON_CHEVRON_DIRECTION.LEFT}
        visible={isPrevBtnVisible}
        onClick={onClickPrevBtn}
      />

      <TabScrollButton
        buttonProps={buttonProps}
        className={rightArrowClassName}
        visible={isNextBtnVisible}
        onClick={onClickNextBtn}
      />
    </>
  )
}

export default TabScrollListButtons
